<template>
  <div class='header-container'>
    <div class='wrapper'>
      <img class='logo' src='../assets/logo.png' alt='logo'/>
      <ul style='display: flex'>
       <li>开发者中心</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { CONSOLE_SITE_URL, MEETING_DOWNLOAD_URL } from '../utils/constants';

const headerNav = [
  { name: '开发者中心', path: '/development'},
];
export default {
  name: 'Header',
  data() {
    return {
      navs: headerNav,
    }
  },
  watch: {
    $route(newValue, oldValue) {
      setTimeout(() => {
        this.$forceUpdate();
      })
    }
  },
  methods: {
    downLoadApp() {
      window.open(MEETING_DOWNLOAD_URL);
    },
    isActive(path, isGroup = false) {
      if (Array.isArray(path)) {
        if (isGroup) {
          let flag = false;
          for (let i = 0; i < path.length; i++) {
            const data = path[i].data;
            if (data.map(p => p.path).includes(this.getUrl())) {
              flag = true;
              break;
            }
          }
          return flag;
        }
        return path.map(p => p.path).includes(this.getUrl())
      }
      return path.includes('?') ? path === this.getUrl() : location.pathname.includes(path);
    },
    handleNavClick(nav) {
      nav.target==="open" ? window.open(nav.path) : this.redirect(nav.path)
    },
    handleLoginOrRegister() {
      window.open(CONSOLE_SITE_URL);
    },
    getUrl() {
      return `${location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname}${location.search}`
    }
  },
}
</script>

<style lang="less">
.header-container {
  z-index: 9999;
  position: sticky;
  top: 0;
  font-size: 20px;
  color: #fff;
  // background: linear-gradient(134deg,#2544a1 3%, #152664 96%);
  background-color: rgb(0, 32, 83);
  height: 93px;
  line-height: 93px;
  transition: all 0.3s;
  display: flex;
  min-width: 1200px;
  justify-content: center;
  > div {
    width: 1149px;
    margin: 0 auto;
    height: 100%;
    display: flex;
  }
  .logo {
    height: 44px;
    margin-top: 24px;
    margin-right: 80px;
    cursor: pointer;
  }
}

</style>
